import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdminUsuario } from 'src/app/models/admin-usuario';
import { HabilEmpresarialProduto, HabilEmpresarialRegistroLicenca } from 'src/app/models/he-produto';
import { Liberacao } from 'src/app/models/liberacao';
import { Licenca, LicencaModulos, Registro } from 'src/app/models/registro';
import { softwares } from 'src/app/models/registro-produto';
import { AbstractService } from 'src/app/services/abstract.service';
import { HabilEmpresarialProdutoService } from 'src/app/services/he-produto.service';
import { LiberacaoService } from 'src/app/services/liberacao.service';
import { RegistroService } from 'src/app/services/registro.service';
import { clone } from 'src/app/utilities/util/clone-utils';
import { DateUtils } from 'src/app/utilities/util/date-utils';

@Component({
  selector: 'habil-cadastro-licenca-habil-empresarial',
  templateUrl: './cadastro-licenca-habil-empresarial.component.html',
  styleUrls: ['./cadastro-licenca-habil-empresarial.component.scss']
})
export class CadastroLicencaHabilEmpresarialComponent implements OnInit {

  constructor(
    private config: DynamicDialogConfig,
    private modal: DynamicDialogRef,
    public service: RegistroService,
    public liberacaoService: LiberacaoService,
    public messageService: MessageService,
    public moduloService: HabilEmpresarialProdutoService
  ) { }

  obj: HabilEmpresarialRegistroLicenca = new HabilEmpresarialRegistroLicenca();
  produto: HabilEmpresarialProduto;
  liberacao: Liberacao;

  graficos = false;
  spedFiscal = false;
  spedPisCofins = false;

  licenca: Licenca = {
    software: "HABIL_EMPRESARIAL",
    dbToken: "",
    modulosLicenciados: [],
    licenceKey: "",
    timestamp: DateUtils.dateTimeToString(new Date()),
    personalizada: false,
    usouDemo: false,
    tipo: "",
    id: 0,
    idInterno: 0,
    creationDate: undefined,
    idHabil: "",
    lastModifiedDate: undefined,
    createdBy: 0,
    lastModifiedBy: 0,
    deleted: false,
  };

  registro: Registro = {
    nome: "",
    cnpj: "",
    email: "",
    cancelamento: null,
    endereco: undefined,
    responsavel: "",
    telefones: [],
    licencas: [],
    id: 0,
    idInterno: 0,
    creationDate: undefined,
    idHabil: "",
    lastModifiedDate: undefined,
    createdBy: 0,
    lastModifiedBy: 0,
    deleted: false,
  };

  softwares = softwares;
  loading = false;

  modulosDisponiveis: LicencaModulos[] = [];
  todosOsModulos: HabilEmpresarialProduto[] = [];
  rotinas = [];
  rotinasComDescricao = [];

  oldTrial = 0;

  versao = [
    { value: "9.8" },
    { value: "9.7" },
    { value: "9.6" },
    { value: "9.5" },
    { value: "9.0" },
    { value: "8.5" },
    { value: "8.0" },
    { value: "7.6" },
    { value: "7.5.1" },
    { value: "7.5" },
    { value: "7.4.5" },
    { value: "7.4.1" },
    { value: "7.4" },
    { value: "7.3.5" },
    { value: "7.3" },
    { value: "7.2.5" },
    { value: "7.2" },
    { value: "7.0" }
  ];
  versaoNFe = [
    { value: "4.16" },
    { value: "4.15" },
    { value: "4.14" },
    { value: "4.13" },
    { value: "4.12" },
    { value: "4.11" },
    { value: "4.10" },
    { value: "4.0" },
    { value: "3.13" },
    { value: "3.12" },
    { value: "3.11" },
    { value: "3.1" },
    { value: "3.0" },
  ];

  incValidade(mais30dias: boolean) {
    if (!this.obj.val) {
      this.obj.val = new Date();
    }
    if (mais30dias) {
      this.obj.val = DateUtils.incDay(this.obj.val, 30);
    }
    else {
      this.obj.val = DateUtils.incMonth(this.obj.val, 1);
    }
  }

  onChangeSolucao() {
    // console.log(this.produto);
    this.obj.nomeSolucao = this.produto.nomeProduto;
    this.obj.mod = this.produto.mod;
    this.obj.acessos = [];
    for (const r of this.produto.rotinas) {
      this.obj.acessos.push(r.id);
    }
  }

  ngOnInit(): void {
    if (this.config.data) {
      this.licenca = this.config.data.licenca;
      this.registro = this.config.data.registro;
      if (this.config.data?.liberacao) {
        this.liberacao = this.config.data.liberacao;
      }
      console.log(this.liberacao);
      if (this.liberacao) {
        this.liberacaoService.preparaLiberacaoHE(this.liberacao.id).subscribe({
          next: (val) => {
            this.obj = clone(val.registroLicenca);

            if (this.obj.trial) {
              this.obj.trial = parseInt(this.obj.trial?.toString())
              if (this.oldTrial < 0) {
                this.oldTrial = 0;
              }
              if (this.obj.trial < 0) {
                this.obj.trial = 0;
              }
              this.oldTrial = clone(this.obj.trial);
            }
            this.registro = val.registro;
            this.licenca = this.registro?.licencas?.find((l) => l.software == 'HABIL_EMPRESARIAL') || this.licenca;
            this.trataModulos();
          }
        })
      } else {
        this.service
          .getRegistroLicenca(this.registro.id, this.licenca.software)
          .subscribe(
            (rl) => {
              if (rl?.body) {
                this.obj = clone(rl.body);
                this.trataModulos();
              }
            },
            (e) => {
              this.service.handleError(e);
            }
          );
      }

    }
  }

  trataModulos() {
    if (this.obj.extra) {
      for (const e of this.obj.extra) {
        if (e == 'G') {
          this.graficos = true;
        } else if (e == 'S1') {
          this.spedFiscal = true;
        } else if (e == 'S2') {
          this.spedPisCofins = true;
        }
      }
    }
    this.moduloService.findAll(0, 9999, "").subscribe((produtos) => {
      produtos = produtos.sort((a, b) => {
        if (a.id > b.id) {
          return 1;
        }
        if (a.id < b.id) {
          return -1;
        }
        return 0;
      });

      this.todosOsModulos = [...produtos];
      this.modulosDisponiveis = [];
      setTimeout(() => {
        this.produto = this.todosOsModulos.find((p) => p.id == this.licenca?.modulosLicenciados[0]?.idModulo);
      }, 100)

    });
  }

  getScrollHeight(): string {
    let fullHeight = window.innerHeight;
    let availableHeight = fullHeight - 250;
    let scrollHeight = availableHeight > 100 ? availableHeight + "px" : "100px";

    return scrollHeight;
  }

  salvar(): void {
    this.obj.extra = [];
    if (this.graficos) {
      this.obj.extra.push('G');
    }
    if (this.spedFiscal) {
      this.obj.extra.push('S1');
    }
    if (this.spedPisCofins) {
      this.obj.extra.push('S2');
    }
    this.obj.chave = formatDate(new Date(), "yyy-MM-dd HHmmss", "pt-BR");
    this.obj.cnpj = this.registro.cnpj;
    this.obj.nome = this.registro.nome;

    if (!this.licenca?.modulosLicenciados?.length) {
      this.licenca.modulosLicenciados.push({
        idModulo: this.produto.id,
        id: 0,
        idInterno: 0,
        creationDate: undefined,
        idHabil: '',
        lastModifiedDate: undefined,
        createdBy: 0,
        lastModifiedBy: 0,
        deleted: false
      })
    }
    this.licenca.modulosLicenciados[0].idModulo = this.produto.id;

    if (!this.obj?.val?.getDate()) {
      this.messageService.add({ severity: 'warn', detail: "Data de validade inválida!" })
      return;
    }
    this.loading = true;
    if (this.oldTrial > this.obj.trial) {
      const trial = this.obj.trial - this.oldTrial;
      const result = new Date(this.obj.val);
      result.setDate(result.getDate() + Number(trial));
      this.obj.val = result;
    }
    if (parseInt(this.obj.trial?.toString()) > 0 && this.permiteAlterarTrial()) {
      const trial = this.obj.trial - this.oldTrial;
      const result = new Date(this.obj.val);
      const daysBetween = DateUtils.daysBetween(new Date(), this.obj.val);

      result.setDate(result.getDate() + Number(trial + daysBetween));

      this.obj.trial = trial + daysBetween;
      if (this.obj.trial > 0) {
        this.obj.val = result;
      }

    }
    if (this.obj.trial < 0) {
      this.obj.trial = 0;
    }
    this.service.save(this.registro).subscribe({
      next: (reg) => {
        this.service
          .saveRegistroLicenca(this.registro.id, this.licenca, this.obj)
          .subscribe(
            (ret) => {
              this.loading = false;
              if (ret) {
                this.modal.close(ret);
              }
            },
            (e) => {
              this.service.handleError(e);
              this.loading = false;
            }
          );
      }
    })

  }

  cancelar(): void {
    this.modal.close();
  }

  bloqueiaAlterarVencimento(): boolean {
    let usuario: AdminUsuario = AbstractService.getLocalStorage("usuario");
    return !usuario?.sysAdmin;
  }

  permiteAlterarTrial(): boolean {
    if (this.obj.val?.getTime() > new Date().getTime() && !this.obj.trial) return false;
    let usuario: AdminUsuario = AbstractService.getLocalStorage("usuario");
    return usuario?.sysAdmin || usuario.grupoAcesso < 3;
  }

  tooltipNovoVencimento(): string {
    const result = new Date(this.obj.val);
    try {
      const daysBetween = DateUtils.daysBetween(new Date(), this.obj.val);
      result.setDate(result.getDate() + Number(this.obj?.trial + daysBetween));
      const formatted = result.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      return `Novo vencimento: ${formatted}`

    } catch (error) {

    }
    return "";

  }

}
